import { gql } from "@apollo/client";
import { CourseFragment } from "./fragments";

export const ADD_INDIVIDUAL_CLIENT = gql`
  mutation createIndividualClient($input: CreateIndividualClientInput!) {
    results: createIndividualClient(input: $input) {
      _id
    }
  }
`;

export const ADD_INDIVIDUAL_CLIENT_REF_ADDRESS = gql`
  mutation addRefAddress($input: AddIndividualClientAddressInput!) {
    results: addRefAddress(input: $input) {
      _id
      firstname
      lastname
      phoneNumber
      email
      addressName
      address {
        address
        place_id
      }
    }
  }
`;

export const UPDATE_INDIVIDUAL_CLIENT_REF_ADDRESS = gql`
  mutation updateRefAddress($id: ID!, $input: UpdateIndividualClientAddressInput!) {
    results: updateRefAddress(id: $id, input: $input) {
      _id
      firstname
      lastname
      phoneNumber
      email
      addressName
      address {
        address
        place_id
      }
    }
  }
`;

export const ADD_COURSE = gql`
  mutation createCourse($courseInput: CreateCourseInput!) {
    results: createCourse(courseInput: $courseInput) {
      _id
      uid
    }
  }
`;

export const EDIT_COURSE = gql`
  mutation updateCourse($input: UpdateCourseInput!) {
    results: updateCourse(input: $input) {
      _id
      uid
    }
  }
`;

export const DELETE_COURSE = gql`
  mutation deleteCourse($id: ID!) {
    results: deleteCourse(id: $id) {
      _id
      uid
    }
  }
`;
